import React from "react";

export default function AuctionDisclaimerTag() {
  return (
    <div className="bg-red-50 border border-red-200 rounded-sm px-3 py-2 text-red-700 animate-pulse">
      <div className="flex items-center gap-2">
        <div> ⚠️ </div>
        <p className="text-[10px] sm:text-xs font-OpenSans">
          <span className="font-bold">Important:</span> Please{" "}
          <span className="font-bold">tap Refresh</span> to view the latest bid
          updates. Place bids well before the auction end time to avoid
          last-minute issues.
        </p>
      </div>
    </div>
  );
}
